import { render, staticRenderFns } from "./RevenueByMessageStats.vue?vue&type=template&id=de4c11fe&scoped=true&"
import script from "./RevenueByMessageStats.vue?vue&type=script&lang=js&"
export * from "./RevenueByMessageStats.vue?vue&type=script&lang=js&"
import style0 from "./RevenueByMessageStats.vue?vue&type=style&index=0&id=de4c11fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4c11fe",
  null
  
)

export default component.exports